var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-store"},[_c('top-bar',{attrs:{"title":"App Store","icon":"store"}}),_c('loading-overlay',{attrs:{"is-loading":_vm.loading}},[_c('app-store-featured'),_c('app-store-grid',{attrs:{"groups":_vm.groups}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }